import { useFeatureGate } from '@trello/feature-gate-client';

import type { MaliciousCardCoverAttachmentFragment } from './MaliciousCardCoverAttachmentFragment.generated';

export const useHasMaliciousCoverAttachment = (
  card: MaliciousCardCoverAttachmentFragment | undefined,
) => {
  const coverAttachmentId = card?.idAttachmentCover;
  const attachments = card?.attachments;

  const { value: isMalwareScanningFeatureEnabled } = useFeatureGate(
    'phx_malware_scanning_for_attachments',
  );

  if (
    !coverAttachmentId ||
    !attachments?.length ||
    !isMalwareScanningFeatureEnabled
  ) {
    return false;
  }

  return attachments.some(
    (attachment) =>
      attachment.id === coverAttachmentId && attachment?.isMalicious,
  );
};
